import type { useAuth0 } from '@auth0/auth0-react';
import type { QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';
import type { LDClient } from 'launchdarkly-js-client-sdk';
import { NotFoundError } from '@/components/common/error/NotFoundError';
import { RouteErrorComponent } from '@/components/common/error/RouteErrorComponent';
import { queryClient } from '@/lib/queryClient';
import type { FlagKeys } from './lib/providers/featureFlagProvider';
import { routeTree } from './routeTree.gen';

export type RouterContext = {
  auth: ReturnType<typeof useAuth0> | null;
  queryClient: QueryClient;
  flagOverrides: Partial<FlagKeys>;
  ldClient: LDClient | undefined;
};

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 30_000,
  defaultNotFoundComponent: NotFoundError,
  defaultErrorComponent: RouteErrorComponent,
  scrollRestoration: true,
  context: {
    queryClient,
    auth: null,
    flagOverrides: {},
    ldClient: undefined,
  },
  getScrollRestorationKey: (location) => {
    const pathRegexes = [/user-management\/(users|invites)$/, /portfolio\/table$/];
    return pathRegexes.some((regex) => regex.test(location.pathname))
      ? location.pathname
      : `${location.pathname}${location.search}${location.hash}`;
  },
});
